import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VChip,{staticClass:"pa-0",style:({
          opacity: (_vm.loading)?0.5:1,
          height: _vm.small?'20px':'28px',
        }),on:{"click":_vm.onChange}},[_c(VAvatar,[_c(VIcon,{attrs:{"small":_vm.small}},[_vm._v(_vm._s(_vm.icon))])],1),(_vm.isOk==1)?_c(VAvatar,{attrs:{"color":"yellow"}},[_c(VIcon,{attrs:{"small":_vm.small}},[_vm._v("mdi-hand-okay")])],1):_c(VAvatar,{attrs:{"color":"red"}},[_c(VIcon,{attrs:{"color":"white","small":_vm.small}},[_vm._v("mdi-help\n    ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }